import { LB_BROWSER_EXTENSION_IDS } from '../../../constant'

export default function sendAuthToExtension (token = null) {
  if (LB_BROWSER_EXTENSION_IDS?.length) {
    try {
      if (typeof window.chrome === 'undefined' && typeof window.browser !== 'undefined') {
        window.chrome = window.browser
      }

      LB_BROWSER_EXTENSION_IDS.forEach((extId) => {
        window.chrome?.runtime?.sendMessage(extId, { type: token ? 'login' : 'logout', token })
      })
    } catch (e) {
      console.log(e)
    }
  }
}
